import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import Home from '@/components/Home'
import Confirm from '@/components/Confirm'
import AdminConfirm from '@/components/AdminConfirm'
import vueScrollto from 'vue-scrollto';
import * as VueGoogleMaps from "vue2-google-maps";
import VModal from 'vue-js-modal'
Vue.use(Router)
Vue.use(VModal, { dialog: true })
Vue.use(vueScrollto)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDxOYOwOgUjkZNn1Y3gJTEmr2P7PvZ6cM4",
    libraries: "places" // necessary for places input
  }
});
export default new Router({

  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: Confirm
    },
    {
      path: '/admin/confirm',
      name: 'adminconfirm',
      component: AdminConfirm
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js